import { ManageCard } from "./ManageCard";
import { METER_TRANSFORMS_BASIC_KEY } from "@stores/subscriptions/constants";
import {
  contractedFreeUnits,
  contractedPricePerUnit,
  perRunEstimate,
  transformsRunsLineItem,
  transformsUsage,
} from "../utils";
import { IAddOnContext, IMeteredAddOnDescriptor } from "../types";

/** Pay-per-run basic transforms. Never the one being sold — customers arrive
 *  here from the legacy card's switch CTA or from the advanced downgrade. */
const transformsBasicMetered = {
  productType: "transforms-basic-metered",
  kind: "metered",
  title: "Transforms",
  getPricePerUnit: contractedPricePerUnit,
  getIncludedUnits: contractedFreeUnits,

  isVisible: ({ subscribed }: IAddOnContext) => !!subscribed,

  getUsage: (ctx: IAddOnContext) =>
    transformsUsage(ctx, METER_TRANSFORMS_BASIC_KEY),

  getUpsertAddOns: () => [
    {
      product_type: "transforms-basic-metered",
      prepaid_units: 1,
    },
  ],

  getEstimateRowItem: (ctx) => ({
    detail: "Basic: SQL",
    price: perRunEstimate(ctx),
  }),

  getBillingRowItem: () => ({ detail: "Basic: SQL" }),
  getPurchaseLineItem: transformsRunsLineItem,

  ManageCard,
} satisfies IMeteredAddOnDescriptor;

export default transformsBasicMetered;
